import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Article detail pages (/article/<id>/) are fully server-rendered by Django,
// including OG/share meta tags. Mounting the homepage <App/> here would wipe
// that content out and replace it with the homepage grid, so only mount the
// SPA when we're actually on the homepage.
if (!window.__ARTICLE_DATA__) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
